// @flow

import { useSelector } from 'react-redux';

import type { FullState } from '../types';

type TypedUseSelectorHook<S> = <SS>(
  selector: (state: S) => SS,
  equalityFn?: (a: SS, b: SS) => boolean,
) => SS;

export const useAppSelector: TypedUseSelectorHook<FullState> = useSelector;
